






import { Component, Prop, Vue } from 'vue-property-decorator';
import '@/assets/styles/global/samclick-global.css';
import 'element-ui/lib/theme-chalk/display.css';
// import '@/assets/themes/simplicity/index.css';


@Component({})
export default class App extends Vue {
  mounted() {
    const pageTitle = process.env.VUE_APP_PAGE_TITLE || 'VJ Group Affiliation';
    // Set the title dynamically
    document.title = pageTitle;
  }
}
